import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'

const useLowestPackagePrices = (packageViews: Array<OfferPackageOptionView> = []) => {
  if (packageViews.length == 0) {
    return { price: null, value: null }
  }
  const { hotelTotal, hotelValue } = packageViews[0] // pkg views are in sorted oder. hence select the first one
  return { price: hotelTotal, value: hotelValue }
}

export default useLowestPackagePrices
